export default __webpack_public_path__ + "Predict logo.svg";